import React from "react";
import UserWrapper from "./user.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import PosMappingsTable from "components/posIntegrations/PosMappingsTable";

const PosMappings = props => {
  return (
    <UserWrapper {...props}>
      <PageTitle
        title="sidebar.posMappings"
        className="plr-15"
        breadCrumb={[
          { name: "sidebar.dashboard" },
          { name: "sidebar.posIntegrations" },
          { name: "sidebar.posMappings" }
        ]}
      />
      <div className="user-tbl">
        <PosMappingsTable {...props} />
      </div>
    </UserWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, null)(PosMappings);

